import script from "./BoonesView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoonesView.vue?vue&type=script&setup=true&lang=js"

import "./BoonesView.vue?vue&type=style&index=0&id=d4fd8826&lang=css"

const __exports__ = script;

export default __exports__